// material

import { Box, BoxProps } from '@material-ui/core';

// ----------------------------------------------------------------------

export default function Logo({ sx }: BoxProps, fill: string) {
  // const { fill } = sx;
  return (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg
        version="1.1"
        id="레이어_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="100%"
        height="100%"
        // style={{ background: 'yellow' }}
        viewBox="0 -200 500 700"
        // style="enable-background:new 0 0 500 319;"
        xmlSpace="preserve"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          // transform="translate(0.000000,1661.000000) scale(0.100000,-0.100000)"
          // fill="#4D4C72"
          fill="#4D4C72"
          // stroke="none"
        >
          <path
            d="M330.9,162.8c-11.7-2.2-20.8-7.3-27.4-14.9c-7.3-7.3-10.6-17.1-10.6-28.8V38.5h101.4v-35H251.7v100.9
		c-23.5,17.6-55.1,25.2-72.4,28.2c-19.7,3.6-37.6,4.7-54.3,2.9c-16.8-1.5-30.6-5.5-41.6-12c-9.8-5.1-15.3-12.8-16.8-22.6h161.9V65.4
		H66.7V38.8h161.9V3.4H25.5v85c0,12.8,2.2,23.7,6.6,32.8c4,9.5,9.8,17.9,17.1,24.4c7.3,6.6,15.7,12,25.9,16.1
		c9.5,4.4,20.1,7.3,31.4,9.1c0.7,0.4,1.5,0.4,2.2,0.4v28.1H11.9v35h249.1v-35H151.3v-26.6c8-0.4,15.7-1.5,23.7-2.9
		c10.9-1.8,21.5-4.7,31.7-8.4c18.8-6.8,35.4-16.1,47-24.2c0.8,4,1.8,7.8,3.1,11.4c2.9,9.8,7.7,18.2,13.5,24.8
		c5.5,6.9,12,12.4,20.1,16.8c7.3,4.4,15.7,7.7,24.4,9.8c8.4,2.2,17.1,3.3,26.6,3.3c8.8,0,17.9-0.7,26.6-2.6c8.8-1.5,16.8-4.4,24.8-8
		c7.7-3.3,14.6-7.3,20.8-12.4v-34.6c-15.3,8.7-29.9,14.6-44.1,17.1C354.9,165.7,341.8,165.7,330.9,162.8"
          />
          <polygon points="447.6,3.4 447.6,72.6 376.8,72.6 376.8,107.9 447.6,107.9 447.6,234.3 488.4,234.3 488.4,3.4 	" />
          <path
            d="M32.6,299c-7.6,1.3-16.3,1.4-22.7,1.4l-0.6-4.7h4.2v-12.8h-3.2v-4.6h21.5v4.6h-3.2v12.3
		c1.3-0.1,2.5-0.2,3.7-0.4L32.6,299z M44.3,310.7v4.6H16.5v-12.3h5.8v7.6H44.3z M19.1,295.6c1.2,0,2.5,0,3.8-0.1v-12.6h-3.8V295.6z
		 M37.5,295.4h-5v-4.7h5v-3.5h-5v-4.7h5v-7.1h5.8v30h-5.8V295.4z"
          />
          <path
            d="M58.1,301.9c6.2,0,11.3-0.4,17.1-1.3l0.6,4.7c-6.6,1.1-12.6,1.4-20,1.4h-3.7v-16.8h13.2v-6.5H52.1v-4.6h19.2
		v15.7H58.1V301.9z M83.9,316.2H78v-40.9h5.8V316.2z"
          />
          <path
            d="M114.7,284.2h-24v-4.6h9v-4.3h5.9v4.3h9.1L114.7,284.2z M102.7,301.3c-5.8,0-10-3.2-10-7.9
		c0-4.6,4.2-7.8,10-7.8c5.8,0,10,3.2,10,7.8C112.7,298.2,108.5,301.3,102.7,301.3 M102.3,310.7h21.9v4.6H96.5v-11.8h5.8V310.7z
		 M102.7,296.9c2.6,0,4.4-1.2,4.4-3.5c0-2.2-1.9-3.4-4.4-3.4c-2.6,0-4.4,1.2-4.4,3.4C98.3,295.7,100.1,296.9,102.7,296.9
		 M128.2,287.8v4.8h-5.4v13.2h-5.8v-30.5h5.8v12.4H128.2z"
          />
          <path
            d="M165.9,297.7c-4.6-1.5-7.7-4.3-9.5-8c-1.9,3.9-5.1,7.1-9.9,8.7l-2.9-4.6c6.8-2.2,9.7-7.5,9.7-12.7v-3.9h5.9
		v3.9c0,5.1,2.9,10,9.5,12L165.9,297.7z M149.9,301.4h27.8v14.7h-5.9v-10h-21.9V301.4z M177.6,299.6h-5.9v-24.3h5.9V299.6z"
          />
          <path
            d="M199.5,286.3c0,6.2,3.2,13.4,9.9,16.5l-3.2,4.6c-4.5-2.1-7.7-6.1-9.5-11c-1.8,5.3-5.1,9.8-9.7,12l-3.3-4.6
		c6.7-3.1,10-10.8,10-17.5V284h-8.4v-4.8h22.4v4.8h-8.1V286.3z M222.3,295.7h-5.9v20.4h-5.8v-40.7h5.8v15.5h5.9V295.7z"
          />
          <path
            d="M260.5,275.3V316h-5.5v-20.3h-3.3v18.5h-5.4v-11.8l-3.3,4.4c-3.6-1.9-6-5.2-7.4-9.3c-1.3,4.7-3.7,8.5-7.5,10.8
		l-3.5-4.4c6.1-3.5,8-10.8,8-18.6v-1.1h-6.7v-4.7h18.4v4.7h-6.1v1.1c0,7.1,2,13.9,8.1,17v-26.4h5.4v15h3.3v-15.6H260.5z"
          />
          <path
            d="M303.1,298.6c-8.4,1.5-17.9,1.7-24.9,1.8l-0.5-4.6c2.3,0,4.8,0,7.4,0v-7.9h5.7v7.7c4-0.2,8.1-0.5,11.9-1
		L303.1,298.6z M294.4,292.1c0.7-3.8,0.8-6.8,0.9-9.2h-15.2v-4.6H301v2.5c0,2.8,0,6.9-0.9,12L294.4,292.1z M289.5,310.7h22.6v4.6
		h-28.4v-12.3h5.8V310.7z M315.7,287.7v4.8h-4.9v13.3H305v-30.5h5.8v12.4H315.7z"
          />
          <path
            d="M327.2,301.9c6.2,0,11.3-0.4,17.1-1.3l0.6,4.7c-6.6,1.1-12.6,1.4-20,1.4h-3.7v-16.8h13.2v-6.5h-13.3v-4.6h19.2
		v15.7h-13.2V301.9z M352.9,316.2h-5.8v-40.9h5.8V316.2z"
          />
          <path
            d="M359.9,303.2c7.2,0,17.2,0,25.7-1.3l0.4,4.2c-8.8,1.8-18.3,1.9-25.3,1.9L359.9,303.2z M384.1,288.1
		c0,5.9-4.9,10-11.2,10c-6.4,0-11.2-4.2-11.2-10c0-5.8,4.8-10,11.2-10C379.2,278,384.1,282.2,384.1,288.1 M367.3,288.1
		c0,3.2,2.4,5,5.5,5c3.1,0,5.5-1.9,5.5-5c0-3.2-2.4-5-5.5-5C369.7,283,367.3,284.9,367.3,288.1 M393.7,316.2h-5.8v-40.9h5.8V316.2z"
          />
          <path
            d="M428.6,284.4c0,7.6,3.2,15,10.1,18l-3.3,4.7c-4.7-2.1-7.8-6.2-9.6-11.2c-1.8,5.4-5.1,9.8-10,12.1l-3.5-4.8
		c7.1-3.1,10.5-10.9,10.5-18.8v-5.9h5.8V284.4z M446.6,316.2h-5.8v-40.9h5.8V316.2z"
          />
          <path
            d="M474.9,298.5c-4.4-1.4-7.5-4.3-9.2-7.9c-1.8,3.9-5,7.1-9.7,8.6l-3-4.6c6.6-2.2,9.5-7.3,9.6-12.3h-8.1v-4.6h22
		v4.6h-8c0.1,4.7,2.9,9.5,9.3,11.6L474.9,298.5z M458.4,301.7h27.2v14.4h-5.8v-9.8h-21.4V301.7z M491,290h-5.4v9.9h-5.8v-24.6h5.8
		v9.8h5.4V290z"
          />
        </g>
      </svg>
    </Box>
  );
}
